/**
 * Sends front-end crashes/errors from the Public site to the backend so they
 * are saved and visible in the Admin Panel → Analytics → Performance page.
 */
import { API_URL } from './apiConfig';

let lastSignature = '';
let lastSentAt = 0;

export function reportError(payload) {
  try {
    const message = (payload && payload.message) || 'Unknown error';
    const signature = `${message}::${(payload && payload.stack ? payload.stack.split('\n')[0] : '')}`;

    // Throttle identical bursts (e.g. a render loop) to avoid flooding.
    const now = Date.now();
    if (signature === lastSignature && now - lastSentAt < 5000) return;
    lastSignature = signature;
    lastSentAt = now;

    const body = JSON.stringify({
      message,
      stack: payload && payload.stack,
      componentStack: payload && payload.componentStack,
      type: (payload && payload.type) || 'manual',
      source: 'public',
      url: window.location.href,
      userAgent: navigator.userAgent,
    });

    // keepalive lets the request finish even if the page is unloading/crashing.
    fetch(`${API_URL}/error-logs`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* never let the reporter itself throw */
  }
}

let installed = false;
export function installGlobalErrorHandlers() {
  if (installed) return;
  installed = true;

  window.addEventListener('error', (event) => {
    reportError({
      type: 'window',
      message: event.message || (event.error && event.error.message) || 'Script error',
      stack: event.error && event.error.stack,
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    reportError({
      type: 'promise',
      message:
        (reason && reason.message) ||
        (typeof reason === 'string' ? reason : 'Unhandled promise rejection'),
      stack: reason && reason.stack,
    });
  });
}
